import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { ToastrService } from 'ngx-toastr';

import { Recording } from '@sc/types';
import { AnalyticsService } from '../../services/analytics/analytics.service';
import { WalletService } from '../../services/wallet/wallet.service';
import { UserService } from '../../services/user/user.service';
import { UserModel } from '@sc/types';
import { GeneralToastComponent } from '../../toasts/general-toast/general-toast.component';

@Component({
  selector: 'sc-download-menu',
  templateUrl: './download-menu.component.html',
  styleUrls: ['./download-menu.component.scss'],
})
export class DownloadMenuComponent implements OnInit {
  @Input() recording: Recording;
  @Input() hostID: string;
  @Input() session: any;
  @Input() event: any;

  user: UserModel;

  constructor(
    private popoverController: PopoverController,
    private toastrService: ToastrService,
    private userService: UserService,
    private analyticsService: AnalyticsService,
    public walletService: WalletService
  ) {}

  async ngOnInit() {
    this.user = await this.userService.getUser();
  }

  async download(format: string) {
    window.open(this.recording[format], '_blank');

    await this.popoverController.dismiss();

    this.toastrService.success(`${this.recording.fileName}.${format}`, `Successfully downloaded Recording`, {
      progressBar: true,
      progressAnimation: 'decreasing',
      closeButton: true,
      tapToDismiss: false,
      timeOut: 5 * 1000,
      toastComponent: GeneralToastComponent,
    });

    await this.analyticsService.track('downloaded recording', {
      success: true,
      format,
      fileName: this.recording.fileName,
      sessionID: this.recording.sessionID,
      showID: this.recording.showID,
    });
  }

  async openRecordingMenu() {
    this.popoverController.dismiss();
  }
}
